import { isEmpty, orderBy, toNumber } from 'lodash';
import { SortOptions } from 'src/components/subHeader/SubHeaderWithSorting.interface';
import { DefaultQueryProps } from 'src/hooks';
import { IProduct, IProductCategory } from 'src/interfaces';
import { checkByKeywords } from 'src/utils';

export const formatSortName = (sort: SortOptions) => {
  switch (sort) {
    case SortOptions.ALPHABETICALLY:
      return '*product_name';
    case SortOptions.DATE_CREATED:
      return 'created_at';
    case SortOptions.LAST_MODIFIED:
      return 'modified_at';
    default:
      return '*product_name';
  }
};

export const filteredProducts = (
  products: IProduct[],
  activeFilters: DefaultQueryProps,
  sort: SortOptions,
  order: 'desc' | 'asc',
  productCategory?: IProductCategory,
) => {
  if (isEmpty(productCategory)) return [];

  let filteredProducts = products.filter((item) =>
    item.product_category_id.includes(productCategory.id),
  );

  if ('name.regexp' in activeFilters) {
    filteredProducts = filteredProducts.filter((product) => {
      if ('name.regexp' in activeFilters) {
        const values = activeFilters['name.regexp'];

        return filterProductByKeywords(values, product);
      }

      return false;
    });
  }

  if ('status.list' in activeFilters) {
    filteredProducts = filteredProducts.filter((product) => {
      if ('status.list' in activeFilters) {
        const values = activeFilters['status.list'];

        return values.some(
          (value) => Boolean(toNumber(value)) === product.active,
        );
      }

      return false;
    });
  }

  if ('product_variation_size_id.list' in activeFilters) {
    filteredProducts = filteredProducts.filter((product) => {
      if ('product_variation_size_id.list' in activeFilters) {
        const values = activeFilters['product_variation_size_id.list'];

        return values.some((value) =>
          product.productVariations.some(
            (item) => item.product_variation_size_id === toNumber(value),
          ),
        );
      }

      return false;
    });
  }

  return orderBy(filteredProducts, formatSortName(sort), order);
};

export const filterProductByKeywords = (
  values: string[],
  product: IProduct,
) => {
  return (
    // Check by product by product name override
    checkByKeywords(values, product.name_override) ||
    // Check by product by product variations group product code
    product.productVariations.some((item) =>
      checkByKeywords(values, item.group_product_code),
    ) ||
    // Check by product by  product variation flavor name
    product.productVariations.some((item) =>
      checkByKeywords(values, item.productVariationFlavor?.name),
    ) ||
    // Check by product by  product variation  name
    product.productVariations.some((item) =>
      checkByKeywords(values, item.name),
    ) ||
    // Check by product by  product variation  product code
    product.productVariations.some((item) =>
      checkByKeywords(values, item.product_code),
    )
  );
};
